import { useState, useCallback } from 'react';

import { resendLogic, ResendState } from 'utils/resendLogic';

import { useInterval } from './useInterval';

export const useResendState = (resendState: ResendState | null) => {
  const [remainingTime, setRemainingTime] = useState(0);

  const updateTimer = useCallback(() => {
    const timeLeft = resendLogic.getRemainingTime(resendState);
    setRemainingTime(timeLeft);
  }, [resendState]);

  const isTimerActive = resendLogic.getRemainingTime(resendState) > 0;

  useInterval(updateTimer, isTimerActive ? 1000 : null);

  const getFormattedTime = useCallback((): string => {
    if (remainingTime <= 0) return '';

    const minutes = Math.floor(remainingTime / 60);
    const seconds = remainingTime % 60;

    if (minutes > 0) {
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    }
    return `${seconds}s`;
  }, [remainingTime]);

  return {
    remainingTime,
    getFormattedTime,
  };
};
